import React from 'react';
import { Grid, Header, Segment } from 'semantic-ui-react';
import HeaderSmall from './HeaderSmall';
import FooterBlock from './FooterBlock';

const PageNotFound = () => (
  <div>
    <HeaderSmall />
    <Segment style={{ padding: '8em 0em' }} vertical>
      <Grid container stackable verticalAlign="middle">
        <Grid.Row>
          <Grid.Column width={8}>
            <Header as="h3" style={{ fontFamily: 'PT+Sans', fontSize: '2em' }}>
              Oops! Something Went Wrong
            </Header>
            <p style={{ fontSize: '1.2em' }}>
              We couldn&apos;t find that page sorry.
            </p>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </Segment>
    <FooterBlock />
  </div>
);

export default PageNotFound;



// WEBPACK FOOTER //
// ./src/components/PageNotFound.js